var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCreditPassIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3965 12.5156H16.2145",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2969 14.1846H17.3909",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20715 14.1845V13.5015C5.20715 12.2235 6.2682 11.1885 7.5762 11.1885C8.8832 11.1885 9.9442 12.2235 9.9442 13.5015V14.1845H5.20715Z",
    stroke: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.52731 8.522C6.52731 7.947 6.99331 7.481 7.56831 7.481C8.14131 7.481 8.60831 7.947 8.60831 8.522C8.60831 9.097 8.14131 9.563 7.56831 9.563C6.99331 9.563 6.52731 9.097 6.52731 8.522Z",
    stroke: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 7.228V14.772C3 15.451 3.55 16 4.229 16H17.772C18.45 16 19 15.451 19 14.772V7.228C19 6.55 18.45 6 17.772 6H4.229C3.55 6 3 6.55 3 7.228Z",
    stroke: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCreditPassIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CreditPassIcon.7474bb7e.svg";
export { ForwardRef as ReactComponent };